import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

const SHARED_KEY = 'sa_shared_at';
const DISMISSED_KEY = 'sa_claim_dismissed_at';
const CLAIM_URL = 'https://luma.com/hackaton?coupon=0T24BJ';

const ClaimBanner = () => {
    const [visible, setVisible] = useState(false);
    const location = useLocation();

    useEffect(() => {
        try {
            const shared = window.localStorage.getItem(SHARED_KEY);
            const dismissed = window.localStorage.getItem(DISMISSED_KEY);
            setVisible(Boolean(shared) && !dismissed);
        } catch {
            // localStorage unavailable, leave hidden
        }
    }, []);

    const isAdminRoute = location.pathname === '/login' || location.pathname.startsWith('/dashboard');
    if (!visible || isAdminRoute) return null;

    const dismiss = () => {
        try {
            window.localStorage.setItem(DISMISSED_KEY, String(Date.now()));
        } catch {}
        setVisible(false);
    };

    return (
        <div className="bg-brand-red text-white">
            <div className="max-w-6xl mx-auto px-4 py-2.5 flex items-center gap-3">
                <span className="text-sm sm:text-base font-medium leading-snug">
                    You earned a free student ticket.{' '}
                    <span className="text-white/75 text-xs sm:text-sm">@edu emails only.</span>
                </span>
                <a
                    href={CLAIM_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="group ml-auto flex-shrink-0 inline-flex items-center gap-1.5 bg-white text-brand-ink hover:bg-brand-bg font-semibold text-sm px-3.5 py-1.5 rounded-full transition-colors"
                >
                    Claim now
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" className="transition-transform group-hover:translate-x-0.5" aria-hidden="true">
                        <line x1="5" y1="12" x2="19" y2="12" />
                        <polyline points="12 5 19 12 12 19" />
                    </svg>
                </a>
                <button
                    type="button"
                    onClick={dismiss}
                    aria-label="Dismiss"
                    className="flex-shrink-0 w-7 h-7 flex items-center justify-center rounded-full hover:bg-white/15 transition-colors"
                >
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                        <line x1="6" y1="6" x2="18" y2="18" />
                        <line x1="18" y1="6" x2="6" y2="18" />
                    </svg>
                </button>
            </div>
        </div>
    );
};

export default ClaimBanner;
